import React, { useMemo } from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { getFormQuestionAttributeEndDateQuestionUuid, getFormQuestionAttributeStartDateQuestionUuid } from "reduxSlices/formBuilderSlice"
import { CURRENT_DATE } from "utils/dateDifferenceHelpers"
import FormsyValidation from "shared/FormsyValidation"

// The date selects do not offer the current date once the other date is using
// it, so this guards a form whose questions were not built through them.
const DatesAreNotBothCurrentDateValidation = ({ sectionIndex, questionIndex }) => {
  const questionEndDateQuestionUuid = useSelector(getFormQuestionAttributeEndDateQuestionUuid({ sectionIndex, questionIndex }))
  const questionStartDateQuestionUuid = useSelector(getFormQuestionAttributeStartDateQuestionUuid({ sectionIndex, questionIndex }))

  const value = useMemo(
    () => [questionEndDateQuestionUuid, questionStartDateQuestionUuid],
    [questionEndDateQuestionUuid, questionStartDateQuestionUuid],
  )

  return (
    <FormsyValidation
      name={`sections[${sectionIndex}].questions[${questionIndex}].datesAreNotBothCurrentDate`}
      value={value}
      validations={{
        datesAreNotBothCurrentDate(_model, val) {
          if (val?.every((uuid) => uuid === CURRENT_DATE)) return "Only one date may be the current date"
          return true
        },
      }}
    />
  )
}

DatesAreNotBothCurrentDateValidation.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default DatesAreNotBothCurrentDateValidation
